const initialState = {
    pagos: [],
};

const formapagoredux = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_FORMA_PAGOS':
            const pagoExistente = state.pagos.find(pago => pago.value === action.payload.value);
            if (pagoExistente) {
                return {
                    ...state,
                    pagos: state.pagos.map(pago =>
                        pago.value === action.payload.value ? { ...pago, ...action.payload } : pago
                    )
                };
            } else {
                return {
                    ...state,
                    pagos: [...state.pagos, action.payload]
                };
            }
        case 'DELETE_FORMA_PAGO' :
            return {
                ...state,
                pagos: state.pagos.filter(pago => pago.value !== action.payload)
            }
        case 'RESET_FORMA_PAGOS' : 
            return {
                ...state,
                pagos: []
            }
        default:
            return state;
    }

}

export default formapagoredux;